/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useFacade = (data = []) => {
  const getSelfCode = (item) => {
    switch (item.type) {
      case 'continent':
        return item.continent_code;
      case 'country':
        return item.country_code;
      case 'region':
        return item.region_code;
    }
  };

  const getParentCode = (item) => {
    switch (item.type) {
      case 'continent':
        return null;
      case 'country':
        return item.continent_code;
      case 'region':
        return item.country_code;
    }
  };

  const parseSelectedLocation = (string) => {
    const [_include = '', _exclude = ''] = string.split('|');
    const include = _include.split(',');
    const exclude = _exclude.split(',');

    return {
      include,
      exclude,
    };
  };

  const selection = parseSelectedLocation('');

  const parseItemId = (itemId) => {
    let amountOfUnderscores = 0;
    for (const it of itemId) {
      if (it === '_') {
        amountOfUnderscores++;
      }
    }
    if (amountOfUnderscores !== 3) {
      throw new Error('amountOfUnderscores is not 3');
    }
    const [continent, country, region, city] = itemId.split('_');
    return [continent, country, region, city];
  };

  const toParent = (itemId) => {
    const items = parseItemId(itemId);
    let lastIndex = items.indexOf('') - 1;
    if (lastIndex === -2) {
      lastIndex = items.length - 1;
    }
    items[lastIndex] = '';
    return items.join('_');
  };

  // uniqueId - included/excluded/partially included
  const isIncluded = (itemId) => {
    if (selection.include.includes(itemId)) {
      return true;
    }
    if (selection.exclude.includes(itemId)) {
      return false;
    }
    const parentId = toParent(itemId);
    if (selection.exclude.includes(parentId)) {
      return false;
    }
    if (selection.include.includes(parentId)) {
      return true;
    }
    const parentParent = toParent(parentId);
    if (selection.exclude.includes(parentParent)) {
      return false;
    }
    return selection.include.includes(parentParent);
  };

  function createUniqueIdToItem(data) {
    const resultMap = new Map();
    data.forEach((item) => {
      resultMap.set(item.uniq_id, item);
      if (item.countries) {
        item.countries.forEach((country) => {
          resultMap.set(country.uniq_id, country);
          if (country.regions) {
            country.regions.forEach((region) => {
              resultMap.set(region.uniq_id, region);
            });
          }
        });
      }
    });
    return resultMap;
  }

  const uniqueIdToItemMap = useMemo(() => {
    return createUniqueIdToItem(data);
  }, [data]);

  return {
    uniqueIdToItemMap,
  };
};
